export const APP_CREATOR = '@iFood';

export const APP_NAME = 'iFood Developer';
